<ispui-switcher
  [formlyAttributes]="field"
  [formControl]="formControl"
  [class.switcher_fullwidth]="props.isFullWidth"
>
  <ispui-switcher-option
    *ngFor="let option of props.optionsUi$ | async; trackBy: trackByOption"
    [skey]="option.value"
  >
    <isp-svg-icon
      *ngIf="option.icon"
      class="switcher-option__icon"
      [name]="option.icon"
      [size]="'20px'"
    ></isp-svg-icon>
    {{ option.text }}
  </ispui-switcher-option>
</ispui-switcher>
